import React, { Fragment, useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import SignIn from './SignIn';
import ProductDetails from './ProductList';
import EditProduct from './EditProduct';
import AddProduct from './AddProduct';
import EpisodeManagement from './EpisodeManagement';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/admin.css';
import PrivateRoute from '../../../helper/PrivateRouteAdmin';
import { CartContext } from '../../../context/CartContext';
import LoaderMain from '../../../components/LoaderMain';
import CreateUserReview from './UserReview/CreateUserReview';
import ListUserReview from './UserReview/ListUserReview';
import ViewReviewDetail from './UserReview/ViewReviewDetail';
import OrdersWorkspace from './OrdersWorkspace';
import UserList from './UsersList';
import MarketplaceListings from './MarketplaceListings';

const AdminPanel = () => {

  const { mainloder, mainstopAnimation, mainstartAnimation, mainplayer } = useContext(CartContext);

  // UseEffect hook here
  useEffect(() => {
    if (mainloder) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [mainloder]);

  return (
    <Fragment>

      {mainloder && (
        <div className="loader-main">
          <LoaderMain startAnimationMain={mainstartAnimation} stopAnimationMain={mainstopAnimation} player={mainplayer} />
        </div>
      )}

      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/product" element={<PrivateRoute> <ProductDetails /> </PrivateRoute>} />
        <Route path="/marketplace" element={<PrivateRoute> <MarketplaceListings /> </PrivateRoute>} />
        <Route path="/edit-product/:id" element={<PrivateRoute> <EditProduct /> </PrivateRoute>} />
        <Route path="/add-product" element={<PrivateRoute> <AddProduct /> </PrivateRoute>} />
        <Route path="/manage" element={<PrivateRoute> <EpisodeManagement /> </PrivateRoute>} />
        <Route path="/create-user-review/:id" element={<PrivateRoute> <CreateUserReview /> </PrivateRoute>} />
        <Route path="/list-user-review/:id" element={<PrivateRoute> <ListUserReview /> </PrivateRoute>} />
        <Route path="/view-review/:id" element={<PrivateRoute> <ViewReviewDetail /> </PrivateRoute>} />
        <Route path="/order" element={<PrivateRoute> <OrdersWorkspace /> </PrivateRoute>} />
        <Route path="/fulfillment" element={<PrivateRoute> <OrdersWorkspace initialView="fulfillment" /> </PrivateRoute>} />
        <Route path="/user" element={<PrivateRoute> <UserList /> </PrivateRoute>} />
      </Routes>
    </Fragment>
  );
}

export default AdminPanel;
